import { createSelector } from 'reselect';
import { getConnector } from '../services/PatientFacingClient';
import { RootState } from '../store';

export const messageIdSelector = (
  state: RootState,
  props: { $lastModified: number; id?: string; messageId?: string }
) => props.messageId || props.id;
export const messageSelector = createSelector(
  getConnector,
  messageIdSelector,
  (connector: any, id: string) => connector.client.messages.getById(id)
);

export const messagesIdsSelector = (state: RootState) => Object.keys(state.messages);
export const messagesSelector = createSelector(
  getConnector,
  messagesIdsSelector,
  (connector: any, ids: string[]) =>
    ids
      .map((id) => connector.client.messages.getById(id))
      .filter((m) => m)
      .sort((a, b) => a.sortNumber - b.sortNumber)
);
